import { config } from '@/_helpers'
import { userService } from '@/_services'
import axios from 'axios'

let axiosHeaders = { 'Content-Type': 'application/json' }
let token = localStorage.getItem('access_token')
let tokenCheck = null

if (token && token.length > 0) {
  axiosHeaders.Authorization = 'Bearer ' + token
}

function isTokenValid () {
  if (!tokenCheck) {
    tokenCheck = axios.get(`${config.apiUrl}user/get`, {
      headers: { Authorization: 'Bearer ' + token },
      timeout: 8000
    })
    .then(() => true)
    .catch(e => e.response?.status !== 401)
    .finally(() => { tokenCheck = null })
  }
  return tokenCheck
}

export const $_app_server = axios.create({
  baseURL: config.apiUrl,
  headers: axiosHeaders
})

$_app_server.interceptors.response.use(response => response, error => errorHandler(error))

async function errorHandler (error) {
  console.log(312);
  
  if (error.response?.status === 401 && error.config && !error.config._tokenChecked) {
    error.config._tokenChecked = true
    if (!(await isTokenValid())) {
      userService.logout()
    }
  }
  return Promise.reject(error)
}